module.exports = __webpack_public_path__ + "static/media/night6.279db763.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/night6.jpeg
// module id = 29
// module chunks = 0